import React, { useState, useEffect } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NotificationToast = ({ notification, onClose, onNavigate }) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timerIn = setTimeout(() => setIsVisible(true), 100);
        const timerOut = setTimeout(() => {
            setIsVisible(false);
            setTimeout(onClose, 500);
        }, 5000);

        return () => {
            clearTimeout(timerIn);
            clearTimeout(timerOut);
        };
    }, [notification]);

    const handleClick = () => {
        if (!isVisible) return;
        setIsVisible(false);
        setTimeout(() => {
            if (notification.navigation) {
                onNavigate(notification);
            }
            onClose();
        }, 500);
    };

    const getIcon = (type) => {
        const config = {
            'DEFAULT': { icon: LucideIcons.Bell, color: 'text-gray-400' },
            'MESSAGE': { icon: LucideIcons.Mail, color: 'text-blue-400' },
            'COMMENT': { icon: LucideIcons.MessageCircle, color: 'text-green-400' },
            'GIFT': { icon: LucideIcons.Gift, color: 'text-yellow-400' },
            'LIKE': { icon: LucideIcons.Heart, color: 'text-pink-400' },
            'CONNECTION': { icon: LucideIcons.UserPlus, color: 'text-teal-400' },
            'AMPLIFY': { icon: LucideIcons.Flame, color: 'text-yellow-400' },
            'ECHO': { icon: LucideIcons.MessageSquareReply, color: 'text-cyan-400' },
            'QUEST_COMPLETE': { icon: LucideIcons.Award, color: 'text-purple-400' },
            'SEAL_REVEALED': { icon: LucideIcons.Unlock, color: 'text-indigo-400' },
        };
        const { icon: Icon, color } = config[type] || config['DEFAULT'];
        return <Icon size={20} className={`${color} mr-3`} />;
    };

    return (
        <div
            className={`fixed top-28 left-1/2 -translate-x-1/2 w-full max-w-md p-4 z-[9999] transition-all duration-500 ease-in-out cursor-pointer ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}
            onClick={handleClick}
        >
            <div className="bg-gray-800/90 backdrop-blur-md rounded-lg shadow-2xl p-4 flex items-center justify-center text-white border border-purple-500/50">
                {getIcon(notification.type)}
                <div className="flex-1">
                    <p className="text-sm font-bold">{notification.fromUserName || t('notificationToast.title')}</p>
                    <p className="mt-1 text-sm text-gray-300">{notification.message}</p>
                </div>
                <button className="ml-4 inline-flex text-gray-400 hover:text-gray-200" onClick={(e) => { e.stopPropagation(); onClose(); }}>
                    <span className="sr-only">{t('notificationToast.close')}</span>
                    <LucideIcons.X size={20} />
                </button>
            </div>
        </div>
    );
};

export default NotificationToast;